import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      id: 1,
      title: 'استشارات إدارية',
      description: 'نقدم استشارات إدارية متخصصة لتطوير أعمالك وتحسين الأداء المؤسسي',
      icon: 'ri-briefcase-line',
      image: 'https://public.readdy.ai/ai/img_res/e9ebd63cbf9c2698a8ab3430c2befc32.jpg',
      features: ['تحليل الأداء المؤسسي', 'تطوير الاستراتيجيات', 'إدارة التغيير', 'تحسين العمليات']
    },
    {
      id: 2,
      title: 'التخطيط الاستراتيجي',
      description: 'نساعدك في وضع خطط استراتيجية فعالة لتحقيق أهدافك المؤسسية',
      icon: 'ri-line-chart-line',
      image: 'https://readdy.ai/api/search-image?query=strategic%20planning%20session%20with%20charts%20and%20graphs%20on%20modern%20digital%20screens%2C%20clean%20white%20background%2C%20professional%20business%20environment%2C%20corporate%20setting%2C%20high%20quality%20photography&width=800&height=600&seq=service2&orientation=landscape',
      features: ['تحليل السوق', 'وضع الأهداف', 'خطط التنفيذ', 'قياس الأداء']
    },
    {
      id: 3,
      title: 'تطوير الموارد البشرية',
      description: 'برامج تدريبية وتطويرية لتنمية مهارات فريق العمل',
      icon: 'ri-team-line',
      image: 'https://readdy.ai/api/search-image?query=professional%20training%20session%20with%20diverse%20team%20members%20in%20modern%20training%20room%2C%20clean%20bright%20background%2C%20corporate%20learning%20environment%2C%20high%20quality%20professional%20photography&width=800&height=600&seq=service3&orientation=landscape',
      features: ['برامج تدريبية', 'تقييم الأداء', 'تطوير المهارات', 'بناء الفرق']
    },
    {
      id: 4,
      title: 'الحلول التقنية',
      description: 'حلول تقنية متكاملة لتحسين كفاءة العمل وتطوير الأنظمة',
      icon: 'ri-computer-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20technology%20solutions%20with%20digital%20interfaces%20and%20innovative%20systems%2C%20clean%20minimalist%20background%2C%20professional%20tech%20environment%2C%20high%20quality%20photography%2C%20futuristic%20atmosphere&width=800&height=600&seq=service4&orientation=landscape',
      features: ['أنظمة إدارية', 'تطبيقات مخصصة', 'تحليل البيانات', 'الأمن السيبراني']
    },
    {
      id: 5,
      title: 'التسويق الرقمي',
      description: 'استراتيجيات تسويقية رقمية لزيادة الوصول وتحقيق النمو',
      icon: 'ri-megaphone-line',
      image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20workspace%20with%20social%20media%20analytics%20and%20creative%20content%20on%20screens%2C%20clean%20modern%20background%2C%20professional%20marketing%20environment%2C%20high%20quality%20photography&width=800&height=600&seq=service5&orientation=landscape',
      features: ['إدارة وسائل التواصل', 'تحسين محركات البحث', 'الإعلانات الرقمية', 'تحليل الأداء']
    },
    {
      id: 6,
      title: 'الاستشارات المالية',
      description: 'استشارات مالية متخصصة لإدارة الموارد وتحقيق الاستدامة المالية',
      icon: 'ri-money-dollar-circle-line',
      image: 'https://readdy.ai/api/search-image?query=financial%20consulting%20with%20professional%20charts%20and%20financial%20reports%2C%20clean%20bright%20background%2C%20corporate%20finance%20environment%2C%20high%20quality%20professional%20photography&width=800&height=600&seq=service6&orientation=landscape',
      features: ['التخطيط المالي', 'إدارة الميزانيات', 'التحليل المالي', 'تقييم الاستثمارات']
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h1 className="text-5xl font-bold mb-6">خدماتنا المتميزة</h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              نقدم مجموعة شاملة من الخدمات الاحترافية المصممة لتلبية احتياجات مؤسستك وتحقيق أهدافك
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={service.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="relative h-64 w-full overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 to-transparent"></div>
                  <div className="absolute bottom-6 right-6 w-16 h-16 flex items-center justify-center bg-white rounded-full shadow-lg">
                    <i className={`${service.icon} text-3xl text-blue-600`}></i>
                  </div>
                </div>
                
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
                  
                  <div className="space-y-3 mb-6">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-3">
                        <i className="ri-check-line text-lg text-green-500"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  <Link 
                    to={`/services/${service.id}`}
                    className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <span>تفاصيل الخدمة</span>
                    <i className="ri-arrow-left-line"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center text-white">
            <h2 className="text-4xl font-bold mb-6">هل تحتاج إلى استشارة مجانية؟</h2>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              تواصل معنا الآن واحصل على استشارة مجانية من فريق الخبراء لدينا
            </p>
            <Link 
              to="/request-service"
              className="inline-flex items-center gap-3 bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span>اطلب خدمة الآن</span>
              <i className="ri-arrow-left-line"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}